import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, PropType, computed } from "vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import NaverMap from "@/components/map/NaverMap.vue";
import StreetView from "@/components/map/StreetView.vue";
import SegmentedControl from "@/components/shared/SegmentedControl.vue";
import { IBusStopData } from "@/domain/entities/busStop";


const __default__ = {
  name: "MapOfBusStop",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  targetBusStop: {
    type: Object as PropType<IBusStopData>,
    default: null,
  },
},
  emits: ["onClickClose"],
  setup(__props, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "9f841048-segmentHeight": (segmentHeight.value)
}))

const props = __props;



const currentSegmentIndex = ref(0);
const segmentHeight = computed(() =>
  props.targetBusStop.shouldShowStreetView ? "48px" : "0px"
);

const onChangedSegmentIndex = (index: number) => {
  currentSegmentIndex.value = index;
};

const __returned__ = { props, currentSegmentIndex, segmentHeight, onChangedSegmentIndex, NavigationBar, NaverMap, StreetView, SegmentedControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})